module.exports = __webpack_public_path__ + "static/media/bridgewater.2ba716dc.jpg";